module.exports = __webpack_public_path__ + "img/lightbulb-circle.cd5c88f0.png";